import { ApiOrderRequest } from '@interfaces/api-order-request';
import { TreatmentConsultationRequest } from '@models/consultation-request/treatment-consultation-request';
import { OrderRequest } from '@models/order-request';

export class ConsultableOrderRequest implements ApiOrderRequest {
  public readonly orderingEndpoint: string = '/api/v1/order-consultation';

  public order: OrderRequest;
  public consult: TreatmentConsultationRequest;

  // The aggregator endpoint reads this top-level flag, not the one inside the order.
  public recurly?: boolean;

  public constructor(order: OrderRequest, consult: TreatmentConsultationRequest) {
    this.order = order;
    this.consult = consult;
    this.recurly = order.recurly;
  }
}
